import React, { useRef, useState } from "react";
import Box from "@amzn/meridian/esm/components/box";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Icon from "@amzn/meridian/esm/components/icon";
import Popover from "@amzn/meridian/esm/components/popover";
import PopoverHeader from "@amzn/meridian/esm/components/popover/popover-header";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import userIcon from "@amzn/meridian-tokens/base/icon/user";

import { truncateAttendees } from "../../utils/SummaryUtil";

const AttendeeListInDetailPage = ({ attendeeNameList }) => {
  // Attendee list Popover
  const buttonRef = useRef();
  const [open, setOpen] = useState(false);
  const onClickButton = () => setOpen(true);
  const onClose = () => setOpen(false);

  return (
    <Row spacing="none" spacingInset="none">
      <Icon tokens={userIcon} color="secondary" />
      <Row width="4px" />
      <Box width="190px">
        <Text type="b100" color="secondary" fontFamily="amazonEmber">
          {truncateAttendees(attendeeNameList)}
        </Text>
      </Box>

      <Button onClick={onClickButton} ref={buttonRef} type="link" size="small" aria-haspopup="dialog" aria-expanded="false">
        <Theme tokens={{ textColorPrimary: "#006D5B" }}>
          <Text type="b100" fontFamily="amazonEmber">
            All attendees
          </Text>
        </Theme>
      </Button>
      <Theme tokens={{ popoverHeaderFontSize: "14px", popoverHeaderLineHeight: "16px" }}>
        <Popover anchorNode={buttonRef.current} open={open} onClose={onClose} position="bottom" alignment="end" spacingInset="400">
          <PopoverHeader closeLabel="Close">All attendees</PopoverHeader>

          {/*Attendee name list*/}
          <Box width="186px" spacingInset="none" spacing="none">
            {attendeeNameList
              .split(",")
              .filter((name) => name.trim() !== "")
              .map((name, index) => (
                <Theme tokens={{ textColorPrimary: "#232F3E" }}>
                  <Text key={index} type="b100" color="primary" fontFamily="amazonEmber" alignment="left">
                    {name.trim()}
                  </Text>
                </Theme>
              ))}
          </Box>
        </Popover>
      </Theme>
    </Row>
  );
};

export default AttendeeListInDetailPage;
